module.exports = __webpack_public_path__ + "img/r-202.813fa4d3.jpg";